type DatepickerView = "days" | "months" | "years";
type DatepickerSelection = "date" | "year-month";

export const DATEPICKER_SELECTION_ATTR = 'data-eui-datepicker-selection';
export const DATEPICKER_LANGUAGE_ATTR = 'data-eui-datepicker-language';
export const DATEPICKER_MIN_DATE_ATTR = 'data-eui-datepicker-min-date';
export const DATEPICKER_MAX_DATE_ATTR = 'data-eui-datepicker-max-date';
export const DATEPICKER_INPUT_VALUE = 'data-eui-datepicker-value';

$(() => {
  initDatepickers();
});

function initDatepickers() {
  const datepickerElements = document.querySelectorAll(
    ".eui-input-content-datepicker"
  );
  if (!datepickerElements) return;

  datepickerElements.forEach((element) => {
		const inputErrorMessage = element.querySelector(".eui-input-error-message")!;
		const inputWrapper = element.querySelector(".eui-input-wrapper") as HTMLInputElement;
    const inputField = element.querySelector(".eui-input") as HTMLInputElement;
    const inputId = inputField.id;
    const selection = element.attributes.getNamedItem(DATEPICKER_SELECTION_ATTR)?.value as DatepickerSelection;
    const language = element.attributes.getNamedItem(DATEPICKER_LANGUAGE_ATTR)?.value;

    const calendarPopup = document.querySelector(
      `#${inputId}Popup`
    )! as HTMLElement;
    const calendarDays = document.querySelector(`#${inputId}PopupDays`)!;
    const calendarWeekDays = document.querySelector(
      `#${inputId}PopupWeekDays`
    )!;
    const calendarMonths = document.querySelector(`#${inputId}PopupMonths`)!;
    const calendarYears = document.querySelector(`#${inputId}PopupYears`)!;
    const currentMonthYearElement = document.querySelector(
      `#${inputId}PopupCurrentMonthYear`
    )!;
    const prevMonthButton = document.querySelector(
      `#${inputId}PopupPrevMonth`
    )!;
    const nextMonthButton = document.querySelector(
      `#${inputId}PopupNextMonth`
    )!;

    const daysView = document.querySelector(
      `#${inputId}PopupDaysView`
    )! as HTMLElement;
    const monthsView = document.querySelector(
      `#${inputId}PopupMonthsView`
    )! as HTMLElement;
    const yearsView = document.querySelector(
      `#${inputId}PopupYearsView`
    )! as HTMLElement;

    let currentDate = new Date();
    let selectedDate: Date | null;
    let currentView: DatepickerView = "days";
    const monthNames = getMonthNames(language);

    function formatDate(date: Date) {
      return date.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    }

		function addDate(date: Date) {
			if(selection === "year-month") {
				const monthName = monthNames[currentDate.getMonth()];
				inputField.value = `${monthName} ${currentDate.getFullYear()}`
			} else {
				inputField.value = formatDate(date);
			}

			inputField.setAttribute(DATEPICKER_INPUT_VALUE, dateToString(currentDate));
			element.classList.add('eui-input-content--filled');
			element.classList.remove('eui-input-content--error');
			inputWrapper.classList.remove('eui-input-wrapper--error');
			inputField.classList.remove('eui-input--error');
			inputErrorMessage.classList.add("eui-d-none");
			const event = new Event("change", { bubbles: true });
      inputField.dispatchEvent(event);
    }

    function setView(view: DatepickerView) {
      currentView = view;

      daysView.style.display = "none";
      monthsView.style.display = "none";
      yearsView.style.display = "none";

      if (view === "days") {
        daysView.style.display = "block";
        updateDaysView();
      } else if (view === "months") {
        monthsView.style.display = "block";
        updateMonthsView();
      } else if (view === "years") {
        yearsView.style.display = "block";
        updateYearsView();
      }

      updateHeaderText();
    }

    function updateHeaderText() {
      if (currentView === "days") {
        const monthName = monthNames[currentDate.getMonth()];
        currentMonthYearElement.textContent = `${
          String(monthName).charAt(0).toUpperCase() + String(monthName).slice(1)
        } ${currentDate.getFullYear()}`;
      } else if (currentView === "months") {
        currentMonthYearElement.textContent = `${currentDate.getFullYear()}`;
      } else if (currentView === "years") {
        const startYear = Math.floor(currentDate.getFullYear() / 10) * 10;
        currentMonthYearElement.textContent = `${startYear} - ${startYear + 9}`;
      }
    }

    function updateDaysView() {
			const { minDate, maxDate } = getMinMaxDate(element);

      calendarDays.innerHTML = "";
      calendarWeekDays.innerHTML = "";

      const weekDays = getWeekdayShortNames(language);
      weekDays.forEach((weekDay) => {
        const weekDayElement = document.createElement("div");
        weekDayElement.textContent = weekDay;
        calendarWeekDays.appendChild(weekDayElement);
      });

      const firstDay = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1
      );
      const lastDay = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + 1,
        0
      );

      for (let i = 0; i < firstDay.getDay(); i++) {
        const emptyDay = document.createElement("div");
        calendarDays.appendChild(emptyDay);
      }

      const today = new Date();
      for (let i = 1; i <= lastDay.getDate(); i++) {
        const dayElement = document.createElement("div");
        dayElement.classList.add("calendar-day");
        dayElement.textContent = `${i}`;

        const dayDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          i
        );

        if (
          today.getDate() === i &&
          today.getMonth() === currentDate.getMonth() &&
          today.getFullYear() === currentDate.getFullYear()
        ) {
          dayElement.classList.add("today");
        }

        if (
          selectedDate &&
          selectedDate.getDate() === i &&
          selectedDate.getMonth() === currentDate.getMonth() &&
          selectedDate.getFullYear() === currentDate.getFullYear()
        ) {
          dayElement.classList.add("selected");
        }

				if(maxDate && dayDate > maxDate) {
					dayElement.classList.add("disabled");
				}

				if(minDate && dayDate < minDate) {
					dayElement.classList.add("disabled");
				}

        dayElement.addEventListener("click", () => {
          selectedDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            i
          );
          addDate(selectedDate);
          calendarPopup.style.display = "none";
        });

        calendarDays.appendChild(dayElement);
      }

      updateHeaderText();
    }

    function updateMonthsView() {
			const { minDate, maxDate } = getMinMaxDate(element);

      calendarMonths.innerHTML = "";

      for (let i = 0; i < 12; i++) {
				const monthLastDay = getMonthLastDay(currentDate.getFullYear(), i + 1);
				const localDay = monthLastDay.toString().padStart(2, '0');
				const localMonth = (i + 1).toString().padStart(2, '0');
				const localMaxDate = new Date(`${currentDate.getFullYear()}-${localMonth}-${localDay}T23:59:59`);
				const localMinDate = new Date(`${currentDate.getFullYear()}-${localMonth}-01T23:59:59`);
        const monthElement = document.createElement("div");
        monthElement.classList.add("calendar-month");
        monthElement.textContent = monthNames[i];

        if (
          selectedDate &&
          selectedDate.getMonth() === i &&
          selectedDate.getFullYear() === currentDate.getFullYear()
        ) {
          monthElement.classList.add("selected");
        }

				if(maxDate && localMinDate > maxDate) {
					monthElement.classList.add("disabled");
				}

				if(minDate && localMaxDate < minDate) {
					monthElement.classList.add("disabled");
				}

        monthElement.addEventListener("click", () => {
          currentDate = new Date(currentDate.getFullYear(), i, 1);
          if (selection === "year-month") {
            selectedDate = new Date(currentDate);
            addDate(selectedDate);
            toggleCalendar();
          } else setView("days");
        });

        calendarMonths.appendChild(monthElement);
      }

      updateHeaderText();
    }

    function updateYearsView() {
			const { minDate, maxDate } = getMinMaxDate(element);

      calendarYears.innerHTML = "";

      const startYear = Math.floor(currentDate.getFullYear() / 10) * 10 - 1;
      const endYear = startYear + 11;

      for (let year = startYear; year <= endYear; year++) {
				const localMinDate = new Date(`${year}-01-01`);
				const localMaxDate = new Date(`${year}-12-31T23:59:59`);
        const yearElement = document.createElement("div") as HTMLElement;
        yearElement.classList.add("calendar-year");
        yearElement.textContent = `${year}`;

        if (selectedDate && selectedDate.getFullYear() === year) {
          yearElement.classList.add("selected");
        }

				if(maxDate && localMinDate > maxDate) {
					yearElement.classList.add("disabled");
				}

				if(minDate && localMaxDate < minDate) {
					yearElement.classList.add("disabled");
				}

        yearElement.addEventListener("click", () => {
          currentDate = new Date(year, currentDate.getMonth(), 1);
          setView("months");
        });

        calendarYears.appendChild(yearElement);
      }

      updateHeaderText();
    }

    prevMonthButton.addEventListener("click", () => {
      if (currentView === "days") {
        currentDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth() - 1,
          1
        );
        updateDaysView();
      } else if (currentView === "months") {
        currentDate = new Date(
          currentDate.getFullYear() - 1,
          currentDate.getMonth(),
          1
        );
        updateMonthsView();
      } else if (currentView === "years") {
        currentDate = new Date(
          currentDate.getFullYear() - 10,
          currentDate.getMonth(),
          1
        );
        updateYearsView();
      }
    });

    nextMonthButton.addEventListener("click", () => {
      if (currentView === "days") {
        currentDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth() + 1,
          1
        );
        updateDaysView();
      } else if (currentView === "months") {
        currentDate = new Date(
          currentDate.getFullYear() + 1,
          currentDate.getMonth(),
          1
        );
        updateMonthsView();
      } else if (currentView === "years") {
        currentDate = new Date(
          currentDate.getFullYear() + 10,
          currentDate.getMonth(),
          1
        );
        updateYearsView();
      }
    });

    currentMonthYearElement.addEventListener("click", () => {
      if (currentView === "days") {
        setView("months");
      } else if (currentView === "months") {
        setView("years");
      }
    });

    function toggleCalendar() {
      if (calendarPopup.style.display === "none") {
        const inputRect = inputField.getBoundingClientRect();
				const hasSpace = (window.innerHeight - inputRect.bottom) > (window.innerHeight / 2);
				if(!hasSpace) calendarPopup.style.bottom = "calc(100% + 4px)";

        calendarPopup.style.display = "block";
        if (selection === "year-month") setView("years");
        else setView("days");
      } else {
        calendarPopup.style.display = "none";
      }
    }

    element.addEventListener("click", () => {
      if(element.classList.contains('eui-input-content--disabled')) return;
      toggleCalendar();
    });

    $(element).on("click", ".eui-input-label", (event, _) => {
      event.preventDefault();
    });

    document.addEventListener("click", function (event: Event) {
      if (
        !element.contains(event.target as Node) &&
        !calendarPopup.contains(event.target as Node)
      ) {
        calendarPopup.style.display = "none";
      }
    });

		inputField.addEventListener("change", (event) => {
			const inputElement = event.target as HTMLInputElement;
			if(inputElement.value === '') selectedDate = null;
		})

    calendarPopup.style.display = "none";

    if (selection === "year-month") setView("years");
  });
}

function getMonthNames(locale = "es") {
  const months = [];
  for (let month = 0; month < 12; month++) {
    const date = new Date(2000, month, 1);
    const formatter = new Intl.DateTimeFormat(locale, { month: "long" });
    const monthName = formatter.format(date);
    months.push(
      String(monthName).charAt(0).toUpperCase() + String(monthName).slice(1)
    );
  }
  return months;
}

function getWeekdayShortNames(locale = "es") {
  if (locale === "pt" || locale === "br") {
    return ["2ª", "3ª", "4ª", "5ª", "6ª", "sá", "do"];
  }
  const weekdays = [];
  for (let day = 1; day <= 7; day++) {
    const date = new Date(2021, 0, 3 + (day % 7));
    const fullName = date.toLocaleDateString(locale, { weekday: "short" });
    weekdays.push(fullName.substring(0, 2));
  }
  return weekdays;
}

function getMinMaxDate(element: Element) {
	const minDate = element.getAttribute(DATEPICKER_MIN_DATE_ATTR) != null ? new Date(element.getAttribute(DATEPICKER_MIN_DATE_ATTR)!) : null;
	const maxDate = element.getAttribute(DATEPICKER_MAX_DATE_ATTR) != null ? new Date(element.getAttribute(DATEPICKER_MAX_DATE_ATTR)!) : null;

	return { minDate, maxDate };
}

function getMonthLastDay(year: number, month: number): number {
  return new Date(year, month, 0).getDate();
}

export function dateToString(date: Date | string): string {
	if (typeof date === 'string') date = new Date(date);

	const year: number = date.getFullYear();
	const month: string = (date.getMonth() + 1).toString().padStart(2, '0');
	const dateDay: string = date.getDate().toString().padStart(2, '0');
	const hours: string = date.getHours().toString().padStart(2, '0');
	const minutes: string = date.getMinutes().toString().padStart(2, '0');
	const seconds: string = date.getSeconds().toString().padStart(2, '0');

	return `${year}-${month}-${dateDay}T${hours}:${minutes}:${seconds}`;
}